<template>
  <div class="rounded badge p-2 w-100" :class="type">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['type']
};
</script>

<style lang="scss">
.badge {
  display: inline;
}

.green {
  background: rgba(19, 181, 106, 0.15);
  color: #09B78A;
}

.red {
  color: #D72638;
  background: rgba(215, 38, 56, 0.15);
}

.yellow {
  color: #FCC210;
  background: rgba(252, 194, 16, 0.15);
}
</style>
